import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbstractPageComponent, SdkDictionaryService } from '@dsivd/prestations-ng';

import { BusinessForm } from '../../model/business-form';
import { CadorReference } from '../../model/cador-reference';
import { RefCadorService } from '../../services/ref-cador/ref-cador.service';
import { ElementUtils } from '../../utils/element.utils';

@Component({
    templateUrl: './legal-representative-page.component.html'
})
export class LegalRepresentativePageComponent extends AbstractPageComponent<BusinessForm> implements OnInit {

    wholeValue = ElementUtils.wholeValue;

    relations: CadorReference[];

    constructor(
        protected activatedRoute: ActivatedRoute,
        private dictionaryService: SdkDictionaryService,
        private refCadorService: RefCadorService
    ) {
        super(activatedRoute);
    }

    ngOnInit(): void {
        super.ngOnInit();
        super.setPageTitle(this.dictionaryService.getKeySync('legal-representative.title'));

        this.relations = this.refCadorService.getInitiatorsSync();

        // TODO : known bugs
        // 1. isLegalRepresentativeRequestInitiator boolean is reset to false when validation error occurs
        // Do ValidationHandlerService.updateErrors([])
    }

    newForm(): BusinessForm {
        return new BusinessForm();
    }

    legalRepresentativeRequestInitiatorChange($event: boolean): void {
        if ($event) {
            this.form.legalRepresentative.lastName = this.form.requestOrigin.lastName;
            this.form.legalRepresentative.firstName = this.form.requestOrigin.firstName;
            this.form.legalRepresentative.email = this.form.requestOrigin.email;
        } else {
            this.form.legalRepresentative.lastName = undefined;
            this.form.legalRepresentative.firstName = undefined;
            this.form.legalRepresentative.email = undefined;
        }
    }

}
